export const Page = {
  NEST: "NEST",
  AIC: "AIC",
  DISABLED: "DISABLED",
} as const;
export type Page = (typeof Page)[keyof typeof Page];
